<!-- AI: Status: "in progress", Type: Component, SubType: WizardStep, Reason: Step 1 basics form -->
<div class="flex flex-column gap-4">

    <h3 class="mt-0 mb-1 text-lg font-semibold">
        <i class="fa-regular fa-pen-to-square mr-2"></i>Grundlagen
    </h3>

    <div class="flex flex-column gap-3">
        <!-- Name -->
        <div class="flex flex-column gap-1">
            <label for="lg-poc-name" class="text-sm font-medium">Name <span class="text-red-500">*</span></label>
            <input id="lg-poc-name"
                   type="text"
                   pInputText
                   [(ngModel)]="name"
                   (ngModelChange)="onNameChange()"
                   placeholder="Name des Berechnungslogiktyps"
                   class="w-full"/>
        </div>

        <!-- Alias -->
        <div class="flex flex-column gap-1">
            <label for="lg-poc-alias" class="text-sm font-medium">Alias</label>
            <input id="lg-poc-alias"
                   type="text"
                   pInputText
                   [(ngModel)]="alias"
                   placeholder="Wird automatisch generiert"
                   class="w-full"/>
            <small class="text-500">Wird automatisch aus dem Namen abgeleitet.</small>
        </div>

        <!-- Logic Group -->
        <div class="flex flex-column gap-1">
            <label for="lg-poc-group" class="text-sm font-medium">Logik-Gruppe</label>
            <p-select id="lg-poc-group"
                      [options]="logicGroups"
                      [(ngModel)]="logicGroupId"
                      optionLabel="label"
                      optionValue="value"
                      [filter]="true"
                      filterPlaceholder="Gruppe suchen..."
                      placeholder="Logik-Gruppe auswählen"
                      [showClear]="true"
                      [loading]="loadingGroups"
                      class="w-full">
            </p-select>
        </div>

        <!-- Description -->
        <div class="flex flex-column gap-1">
            <label for="lg-poc-desc" class="text-sm font-medium">Beschreibung</label>
            <textarea id="lg-poc-desc"
                      pTextarea
                      [(ngModel)]="description"
                      placeholder="Optionale Beschreibung"
                      rows="3"
                      class="w-full">
            </textarea>
        </div>
    </div>

    <!-- Footer -->
    <div class="flex justify-content-end pt-3 border-top-1 surface-border">
        <p-button label="Weiter zu Logik-Blöcke"
                  icon="fa-regular fa-arrow-right"
                  iconPos="right"
                  [disabled]="!isValid"
                  (onClick)="onNext()">
        </p-button>
    </div>

</div>
